'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002447 from "./presto.-Presto-Router$$anon$47.js";
import * as $j_presto$002e$002dRegister$002dPage$0024 from "./presto.-Register-Page$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$46() {
  this.biW = null;
  this.biO = null;
  this.biP = false;
  this.biX = null;
  this.biY = false;
  this.bj1 = null;
  this.biU = null;
  this.biV = false;
  this.biQ = null;
  this.biR = false;
  this.biS = null;
  this.biT = false;
  this.biZ = false;
  this.bj0 = false;
  this.biW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bj1 = "RegisterPage";
}
export { $c_Lpresto_PrestoRouter$$anon$46 as $c_Lpresto_PrestoRouter$$anon$46 };
$p = $c_Lpresto_PrestoRouter$$anon$46.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$46;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$46() {
}
export { $h_Lpresto_PrestoRouter$$anon$46 as $h_Lpresto_PrestoRouter$$anon$46 };
$h_Lpresto_PrestoRouter$$anon$46.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.biW;
});
$p.L = (function() {
  if ((!this.biP)) {
    this.biO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.biP = true;
  }
  return this.biO;
});
$p.O = (function() {
  if ((!this.biY)) {
    this.biX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.biY = true;
  }
  return this.biX;
});
$p.E = (function() {
  return this.bj1;
});
$p.t = (function() {
  if ((!this.biV)) {
    this.biU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.biV = true;
  }
  return this.biU;
});
$p.M = (function() {
  if ((!this.biR)) {
    this.biQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.biR = true;
  }
  return this.biQ;
});
$p.Q = (function() {
  if ((!this.biT)) {
    this.biS = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002447.$c_Lpresto_PrestoRouter$$anon$47();
    this.biT = true;
  }
  return this.biS;
});
$p.w = (function() {
  if ((!this.bj0)) {
    this.biZ = false;
    this.bj0 = true;
  }
  return this.biZ;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee377) => ((p) => \u03b4scrutinee377))($j_presto$002e$002dRegister$002dPage$0024.$m_Lpresto_RegisterPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$46 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$46, "presto.PrestoRouter$$anon$46", ({
  Oc: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$46 as $d_Lpresto_PrestoRouter$$anon$46 };
//# sourceMappingURL=presto.-Presto-Router$$anon$46.js.map
